import { httpClient } from "@coworker/http-client";

/**
 * @param {String} code Location code
 * @param {String} name Location name
 * @returns {String} Joined string with <Location code> - <location name>
 */
export const joinLocation = (code, name = "") => `${code} - ${name}`;

/**
 * @param {string|undefined} location Location code and name formatted with " - " in between.
 * @returns {[string, string]} The location code and the location name
 */
export function splitLocation(location) {
  const matches = (location || "").match(/(.+?) - (.+)/);
  if (!matches) return [location || "", ""];
  return matches.slice(1, 3).map((a) => (a || "").trim());
}

export async function fetchAllSalesLocations(fullId) {
  const result = await httpClient.tasks.get("/v1/locations/defined", {
    params: { full_id: fullId },
  });
  return result?.data?.list || [];
}

export function nonSLMFoodLocation(isFoodArticle, hasNoSLMLocations) {
  const sfmLocationList = [];
  if (isFoodArticle && hasNoSLMLocations) {
    const frontendFriendlyObject = {
      location: "SFM",
      locationDescription: "Swedish Food Market",
      department: "",
      isPrimary: true,
      isHomeBase: true,
    };
    sfmLocationList.push(frontendFriendlyObject);
  }
  return { sfmLocationList };
}

export function productQualityLocations(isProductQualityTask) {
  const productQualityLocationsList = [];
  if (isProductQualityTask) {
    const productQualityAreaObject = {
      code: "Quality Area/Cage",
      locationDescription: "",
      department: "",
      isPrimary: false,
      isHomeBase: false,
      section: "Quality Area/Cage",
    };
    const productQualityCageObject = {
      code: "Recovery",
      locationDescription: "",
      department: "",
      isPrimary: false,
      isHomeBase: false,
      section: "Recovery",
    };
    productQualityLocationsList.push(
      productQualityAreaObject,
      productQualityCageObject
    );
  }
  return { productQualityLocationsList };
}

export async function getAllLocationsFromSLM() {
  return await httpClient.tasks.get("/v1/locations/store");
}
